// extracted by mini-css-extract-plugin
export default {"container":"w1Sbt_"};